import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ManhuaDetailsPage from './pages/ManhuaDetailsPage';
import ManhuaReaderPage from './pages/ManhuaReaderPage';
import LegalPage from './pages/LegalPage';
import ContentIntelligencePage from './pages/ContentIntelligencePage';
import MethodologyPage from './pages/MethodologyPage';
import BingeIQBetaPage from './pages/BingeIQBetaPage';
import ProfilePage from './pages/ProfilePage';
import IndustryPreviewPage from './pages/IndustryPreviewPage';
import ConsentBanner from './components/ConsentBanner';
import { RegionProvider } from './contexts/RegionContext';

function App() {
  return (
    <RegionProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/manhua" element={<HomePage initialMode="manhua" />} />
        <Route path="/manhua/:id" element={<ManhuaDetailsPage />} />
        <Route path="/manhua/:id/read/:chapterId" element={<ManhuaReaderPage />} />
        <Route path="/about" element={<LegalPage slug="about" />} />
        <Route path="/terms" element={<LegalPage slug="terms" />} />
        <Route path="/privacy" element={<LegalPage slug="privacy" />} />
        <Route path="/contact" element={<LegalPage slug="contact" />} />
        <Route path="/methodology" element={<MethodologyPage />} />
        <Route path="/bingeiq-beta" element={<BingeIQBetaPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/industry" element={<IndustryPreviewPage />} />
        <Route path="/title/:mediaType/:tmdbId" element={<ContentIntelligencePage />} />
        <Route path="/title/:mediaType/:tmdbId/:slug" element={<ContentIntelligencePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {/* Global consent banner — gates all AdSlots until the user chooses */}
      <ConsentBanner />
    </RegionProvider>
  );
}

export default App;
